import { IIndexable } from 'core-ts-types';

export class PathItem implements IIndexable {
  id: number;
  nk: string;
  title: string;
  presenter: string;
  poll?: number;
  link_to_appt_scheduling: boolean;

  constructor(item: Partial<PathItem>) {
    _.merge(this, item);
  }

  static build(item: Partial<PathItem>): PathItem {
    return new PathItem(item);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/builders/path_item_builder.ts